import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../context/AuthContext";
import { isTokenExpired } from "../utils/tokenUtils";

const INTERVALO_REVISION_MS = 30000;

const useImpersonationSession = () => {
  const { isImpersonating, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  const finalizarSuplantacion = (avisoAutomatico) => {
    const resultado = stopImpersonation();

    if (!resultado.success) {
      Swal.fire({
        icon: "warning",
        title: "Sesión de administrador expirada",
        text: "Tu sesión de administrador ya no es válida. Inicia sesión de nuevo para continuar.",
      });
      navigate("/login");
      return;
    }

    if (avisoAutomatico) {
      Swal.fire({
        icon: "info",
        title: "Suplantación finalizada",
        text: avisoAutomatico,
      });
    }

    navigate("/admin/impersonate");
  };

  // El intervalo usa la referencia para no reiniciarse en cada render.
  const finalizarRef = useRef(finalizarSuplantacion);
  finalizarRef.current = finalizarSuplantacion;

  useEffect(() => {
    if (!isImpersonating) return undefined;

    const intervalo = setInterval(() => {
      if (isTokenExpired(localStorage.getItem("token"))) {
        finalizarRef.current(
          "La sesión del usuario suplantado expiró. Volviste al panel de administración.",
        );
      }
    }, INTERVALO_REVISION_MS);

    return () => clearInterval(intervalo);
  }, [isImpersonating]);

  useEffect(() => {
    const alCambiarSesionEnOtraPestana = (evento) => {
      if (evento.key === "token" && evento.oldValue !== evento.newValue) {
        window.location.reload();
      }
    };

    window.addEventListener("storage", alCambiarSesionEnOtraPestana);
    return () =>
      window.removeEventListener("storage", alCambiarSesionEnOtraPestana);
  }, []);

  return { isImpersonating, finalizarSuplantacion };
};

export default useImpersonationSession;
